export const snackbarReducer = (snackbar = {}, action) => {
  switch (action.type) {
      case 'set_snackbar':
          return action.payload;
      default:
          return snackbar;
  }
}